module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAJUAAAAaCAYAAAC+RB5CAAABMUlEQVRoge3avUrDUByG8bfijdQQHHsJdtIKmXoFcWtB6JRZvAY7dOwVdMqQbvESHCUegleiQYn40UqQPz0n8vwg2xne4eEklA5eGgIMHfkegP+HqGCOqGCOqGCOqGCOqGCOqGAuoKhKLUZnSlb13hPVKtVpc+bjycrDzUNnx74HSLWW01R3bqzJ+e8nnasVz9fKZ8PDTMOfBHBTDXW9udfjw60uO5yOTggqdAFE1VWtJycVWfv6u1HhexJ26lFU7Y32/uTzZy2ma1W+Z+GHHkX1VTxLNXGlts73EnzX26gQrrCjcmslo1TLt9uoVvXpViqy5psqGusi8jUO+wTwk0J32+YjPWnDiq6Ub1LFXhdhlwF/0oO1sF9/6CWigjmigjmigjmigjmigjmigjmigrlXXaRC5si4R+wAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./static/workoff/excelimg/word/wdhjtb1-3.png
// module id = 865
// module chunks = 0